const url = process.env.REACT_APP_API_URL + "/api";
export default {
  get: (locale) => {
    if (locale === "de") return url + "/project-dictionary/dictionary/";
    else return url + "/project-dictionary/dictionary/a-not-existing-url";
  },
};
